export const CACHE_DATA = 'CACHE_DATA';
export const BROWSER_NAVIGATION_BUTTON_PRESSED = 'BROWSER_NAVIGATION_BUTTON_PRESSED';
export const APP_DATA_INIT_CALL = 'APP_DATA_INIT_CALL';
export const LOCALE_SET = 'LOCALE_SET';
